<div>
  <div class="d-flex flex-column gap-3">
    <label class="scope-card d-flex align-items-start gap-2 p-3 rounded"
           [class.scope-card--selected]="scopeType === 'full'">
      <input
        type="radio"
        [attr.name]="scopeTypeGroupName"
        value="full"
        class="form-check-input mt-1"
        [checked]="scopeType === 'full'"
        (change)="scopeType = 'full'; onScopeTypeChange()"
      />
      <div class="flex-grow-1">
        <div class="fw-bold mb-1">{{ 'Settings::DataImport:Scope:FullTitle' | abpLocalization }}</div>
        <div class="text-muted">{{ 'Settings::DataImport:Scope:FullDescription' | abpLocalization }}</div>
      </div>
    </label>

    <label class="scope-card d-flex align-items-start gap-2 p-3 rounded"
           [class.scope-card--selected]="scopeType === 'customized'">
      <input
        type="radio"
        [attr.name]="scopeTypeGroupName"
        class="form-check-input mt-1"
        value="customized"
        [checked]="scopeType === 'customized'"
        (change)="scopeType = 'customized'; onScopeTypeChange()"
      />
      <div class="flex-grow-1">
        <div class="fw-bold mb-1">{{ 'Settings::DataImport:Scope:CustomizedTitle' | abpLocalization }}</div>
        <div class="text-muted">{{ 'Settings::DataImport:Scope:CustomizedDescription' | abpLocalization }}</div>
      </div>
    </label>
  </div>

  <div class="mt-3 p-3 border rounded" *ngIf="scopeType === 'customized'">
    <div class="mb-3">
      <h6 class="fw-bold mb-2">{{ 'Settings::DataImport:Scope:DateRange' | abpLocalization }}</h6>
      <cx-datepicker
        [isMaxDateToday]="true"
        [initialStartDate]="systemStartDate"
        (dateRangeChange)="onDateRangeChange($event)"
      />
    </div>

    <div>
      <div class="d-flex align-items-center justify-content-between mb-2">
        <h6 class="fw-bold mb-0">{{ 'Settings::DataImport:Scope:SelectMetrics' | abpLocalization }}</h6>
        <label class="d-flex align-items-center gap-2 cursor-pointer mb-0">
          <input
            class="form-check-input"
            type="checkbox"
            [checked]="isAllMetricsSelected"
            (change)="onToggleAllMetrics()"
          />
          <span class="small fw-semibold">{{ 'Settings::DataImport:Metrics:All' | abpLocalization }}</span>
        </label>
      </div>
      <div class="row g-2">
        <div class="col-6 col-md-4" *ngFor="let metric of metricOptions">
          <label class="d-flex align-items-center gap-2 p-2 border rounded cursor-pointer metric-checkbox-label">
            <input
              class="form-check-input"
              type="checkbox"
              [checked]="isMetricSelected(metric.id)"
              (change)="onMetricToggle(metric.id)"
            />
            <span>{{ metric.labelKey | abpLocalization }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
